import { api, ensureApiAuthenticated } from '../services/api';

export interface BatchListItem {
  id: string;
  user_id: string;
  name: string;
  status: string;
  item_count: number;
  created_at: string;
  submitted_at: string | null;
  committed_at: string | null;
  notes: string | null;
}

export interface BatchItem {
  id: string;
  batch_id: string;
  mtgjson_uuid?: string | null;
  tcgplayer_id?: string | null;
  catalog_source?: string | null;
  product_line?: string | null;
  card_name: string;
  set_name: string | null;
  card_number: string | null;
  condition: string;
  is_foil: boolean;
  quantity: number;
  location_bin: string | null;
  language: string;
  printing: string;
  estimated_cost: number | null;
  notes: string | null;
  image_url?: string | null;
  tcgplayer_market?: number | null;
  manapool_market?: number | null;
  ck_buylist?: number | null;
  calculated_offer?: number | null;
  tcg_export_market?: number | null;
  tcg_low?: number | null;
  manapool_low?: number | null;
  price_source?: string | null;
  policy_price?: number | null;
  policy_price_debug?: Record<string, unknown> | null;
  offer_ck_floored?: boolean | null;
}

/** Policy fields on GET /batches/{id} are live-computed (same helper as preview-pricing). */

export interface BatchDetail extends BatchListItem {
  items: BatchItem[];
}

export interface BatchSyncChannelsRequest {
  channels: Array<'shopify' | 'manapool'>;
  dry_run?: boolean;
}

export interface BatchSyncChannelsResponse {
  variant_count: number;
  channels: string[];
  outbox_event_id: string | null;
  dry_run: boolean;
}

export async function listBatches(params?: {
  status?: string;
  limit?: number;
  offset?: number;
}): Promise<BatchListItem[]> {
  await ensureApiAuthenticated();
  const response = await api.get<BatchListItem[]>('/batches', { params });
  return response.data || [];
}

export async function getBatch(batchId: string): Promise<BatchDetail> {
  await ensureApiAuthenticated();
  const response = await api.get<BatchDetail>(`/batches/${batchId}`);
  return response.data;
}

export async function syncBatchChannels(
  batchId: string,
  body: BatchSyncChannelsRequest,
): Promise<BatchSyncChannelsResponse> {
  await ensureApiAuthenticated();
  const response = await api.post<BatchSyncChannelsResponse>(
    `/batches/${batchId}/sync-channels`,
    body,
  );
  return response.data;
}
